export const WORDS = [
  "slobber",
  "plunger",
  "hideous",
  "inhaler",
  "grinder",
  "alcohol",
  "shotgun",
  "fattest",
  "fucking",
  "hardons",
  "sarcasm",
  "hotdogs",
  "dogcows",
  "arrakis",
  "asshole",
  "lapland",
  "rapekit",
  "cocaine",
  "disgust",
  "zuccini",
  "bitcoin",
  "crinkly",
  "panties",
  "playboy",
  "squishy",
  "chonker",
  "kerning",
  "latency",
  "fidonet",
  "mongodb",
  "wanking",
  "batcave",
  "lobster",
  "dirtbag",
  "cupcake",
  "footjob",
  "typedef",
  "toilets",
  "gayness",
  "bgcolor",
  "taliban",
  "bukkake",
  "urinals",
  "squirmy",
  "fartles",
  "runtime",
  "hijinks",
  "rugburn",
  "codeine",
  "funnies",
  "sproing",
  "blubber",
  "whatnot",
  "immoral",
  "dogshit",
  "desktop",
  "burrito",
  "penises",
  "notepad",
  "squeezy",
  "degauss",
  "leakage",
  "urinate",
  "unloved",
  "weebles",
  "dingbat",
  "fagface",
  "dickity",
  "painful",
  "molemen",
  "netcode",
  "corndog",
  "ladybug",
  "nutward",
  "baloney",
  "dickery",
  "goonbot",
  "coochie",
  "compile",
  "crontab",
  "firefox",
  "tugboat",
  "hookers",
  "falafel",
  "cockpit",
  "jerkity",
  "browser",
  "crowbar",
  "captcha",
  "frasier",
  "suckery",
  "blather",
  "honking",
  "fluffer",
  "gooning",
  "hooking",
  "cockity",
  "barcode",
  "vicodin",
  "chatgpt",
  "seppuku",
  "viscera",
  "gargled",
  "erotica",
  "boobies",
  "fatness",
  "ecstasy",
  "pervert",
  "monokai",
  "garbage",
  "huggies",
  "beating",
  "friendo",
  "pissmop",
  "mugshot",
  "reacher",
  "babbage",
  "giddyup",
  "buttman",
  "pooping",
  "buzzsaw",
  "unsaved",
  "vampyre",
  "nailgun",
  "peacock",
  "cuckold",
  "bathtub",
  "bonjour",
  "bwahaha",
  "jiggles",
  "vagisil",
  "feynman",
  "bulbous",
  "groping",
  "sploosh",
  "mervyns",
  "buddies",
  "letdown",
  "ashtray",
  "remorse",
  "fucktoy",
  "pththth",
  "suckoff",
  "unclamp",
  "default",
  "faggoty",
  "smoking",
  "infocom",
  "lugnuts",
  "bruises",
  "giggles",
  "fatnuts",
  "swollen",
  "blowjob",
  "shemale",
  "schlong",
  "crapper",
  "crunchy",
  "jizzmop",
  "floomph",
  "heinous",
  "aquaman",
  "despair",
  "demento",
  "balloon",
  "bastard",
  "hotmail",
  "biscuit",
  "naughty",
  "dipshit",
  "mozilla",
  "redneck",
  "boredom",
  "dogbert",
  "nipples",
  "trumpet",
  "creeper",
  "titties",
  "mcboner",
  "breasts",
  "malware",
  "enclave",
  "whopper",
  "cookies",
  "flipper",
  "hurmpth",
  "gophers",
  "bologna",
  "safeway",
  "fellate",
  "camgirl",
  "manhood",
  "bonghit",
  "splorsh",
  "roanoke",
  "filking",
  "lasagna",
  "tragedy",
  "trollop",
  "hooters",
  "cripple",
  "wardial",
  "uncanny",
  "diapers",
  "sheeple",
  "ladyboy",
  "hormpth",
  "offline",
  "noisily",
  "unicode",
  "balding",
  "toddler",
  "blister",
  "chomsky",
  "verdana",
  "squirsh",
  "gurgles",
  "beatbox",
  "mooshed",
  "fucknut",
  "yoinked",
  "webinar",
  "achtung",
  "beatnik",
  "android",
  "pissbag",
  "boolean",
  "egglike",
  "slopjob",
  "kleenex",
  "bumhole",
  "beatoff",
  "dildoes",
  "fisting",
  "nutsack",
  "cockpig",
  "hipster",
  "routers",
  "warthog",
  "timecop",
  "squeeze",
  "erectus",
  "tampons",
  "tighter",
  "farting",
  "wetness",
  "flotsam",
  "slather",
  "licking",
  "jackoff",
  "humping",
  "fairies",
  "soaking",
  "mancunt",
  "suicide",
  "snoring",
  "heretic",
  "glormph",
  "bassoon",
  "mwahaha",
  "pornhub",
  "pampers",
  "pisspig",
  "flubber",
  "dongles",
  "jerking",
  "plugins",
  "torrent",
  "cosplay",
  "bashing",
  "anthrax",
  "frogger",
  "goggles",
  "dribble",
  "muppets",
  "shitter",
  "systemd",
  "printer",
  "handjob",
  "magneto",
  "upskirt",
  "shitbag",
  "webring",
  "obesity",
  "cheddar",
  "fascism",
  "pissing",
  "topless",
  "payload",
  "muffins",
  "wriggle",
  "robocop",
  "beeswax",
  "cockbot",
  "wieners",
  "spackle",
  "whoopie",
  "ritalin",
  "wrinkly",
  "pisscam",
  "slobjob",
  "whatevs",
  "flowery",
  "roofies",
  "uranium",
  "useless",
  "quitter",
  "morlock",
  "catfood",
  "powerpc",
  "shrivel",
  "sputnik",
  "macsbug",
  "buggery",
  "morbius",
  "openbsd",
  "jerkoff",
  "jizzery",
  "ballgag",
  "harambe",
  "spittle",
  "condoms",
  "obscene",
  "verdant",
  "goddamn",
  "scuttle",
  "simcity",
  "buffoon",
  "hrompth",
  "botnets",
  "tucking",
  "yappers",
  "klingon",
  "insulin",
  "idiotic",
  "flaccid",
  "macabre",
  "epstein",
  "heathen",
  "webzine",
  "anyways",
  "nutplay",
  "bumpkin",
  "glitter",
  "cahoots",
  "brothel",
  "taskbar",
  "airlock",
  "femming",
  "necktie",
  "squeaky",
  "plumper",
  "shitbox",
  "soylent",
  "morbing",
  "sigsegv",
  "toaster",
  "sucking",
  "fartbag",
  "buttery",
  "unfunny",
  "reboots",
  "privmsg",
  "hiccups",
  "caveman",
]
